module.exports = __webpack_public_path__ + "static/img/2.38c13e68.jpg";